import request from "@/utils/request";

/**
 * 用户登录
 * @param data object 用户账号密码
 */
export function login(data) {
    return request.post("/login", data, {
        login: false
    });
}

/**
 * 用户手机号注册
 * @param data object 用户手机号 验证码 密码
 */
export function register(data) {
    return request.post("/register", data, {
        login: false
    });
}

/**
 * 用户发送验证码
 * @param data object 用户手机号
 */
export function registerVerify(data) {
    return request.post("/register/verify", data, {
        login: false
    });
}

/*
 * 添加收藏产品
 * */
export function getCollectAdd(id, category) {
    return request.post("collect/add", {
        id: id,
        category: category
    });
}


/*
 * 个人中心
 * */
export function getUser() {
    return request.get("/user");
}

/*
 * 用户信息
 * */
export function getUserInfo() {
    return request.get("/userinfo");
}

/**
* 获取我的足迹
*/
export function visit() {
    return request.get("/visit", {}, { login: false });
}

/*
 * 获取收藏产品
 * */
export function getCollectUser(page, limit) {
    return request.get("/collect/user", { page: page, limit: limit });
}

/*
 * 删除收藏产品
 * */
export function getCollectDel(id, category) {
    return request.post("/collect/del", { id: id, category: category });
}

/*
 * 批量收藏产品
 * */
export function postCollectAll(data) {
    return request.post("/collect/all", data);
}

/*
 * 地址列表
 * */
export function getAddressList(data) {
    return request.get("/address/list", data || {});
}

/*
 * 删除地址
 * */
export function getAddressRemove(id) {
    return request.post("/address/del", {
        id: id
    });
}

/*
 * 设置默认地址
 * */
export function getAddressDefaultSet(id) {
    return request.post("/address/default/set", {
        id: id
    });
}

/*
 * 获取默认地址
 * */
export function getAddressDefault() {
    return request.get("/address/default");
}

/*
 * 修改 添加地址
 * */
export function postAddress(data) {
    return request.post("/address/edit", data);
}

/*
 * 修改密码
 * */
export function edit_pass(data) {
    return request.post("/editpass", data);
}

/*
 * 退出登录
 * */
export function getLogout() {
    return request.get("/logout");
}

/**
 * 我的收藏商品
 */
export function collect_goods(limit) {
    return request.get("/collect/user?limit=" + limit, {}, { login: false });
}

/**
 * 我的收藏商品
 */
export function login_qrcode() {
    return request.get("/login_qrcode", {}, { login: false });
}

/**
 * 我的收藏商品
 */
export function login_countdown(data) {
    return request.post("/login_countdown", data, { login: false });
}


